module.exports = __webpack_public_path__ + "static/media/brand-identity.5cbfdf9b.png";